import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch, provide, createApp, onMounted, onBeforeMount, ref } from 'vue';
  import Menu from '@/components/Menu.vue';
  import axios from 'axios';
  import { useRoute, useRouter } from 'vue-router';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const route = useRoute();

  axios.defaults.baseURL = '/api';

  provide('axios', axios);

  const scrollbarRef = ref(null);
  watch(
    () => route.path,
    () => {
      resetScrollbar();
    }
  );
  const resetScrollbar = () => {
    if (scrollbarRef.value) {
      // Reset the scrollbar's scroll position to the top
      scrollbarRef.value.scrollTo(0, 0);
    }
  };

  const debounce = (callback: (...args: any[]) => void, delay: number) => {
    let tid: any;
    return function (...args: any[]) {
      const ctx = self;
      tid && clearTimeout(tid);
      tid = setTimeout(() => {
        callback.apply(ctx, args);
      }, delay);
    };
  };

  const _ = (window as any).ResizeObserver;
  (window as any).ResizeObserver = class ResizeObserver extends _ {
    constructor(callback: (...args: any[]) => void) {
      callback = debounce(callback, 20);
      super(callback);
    }
  };
  
  const height = ref("");
  onBeforeMount(() => {
    const h = `${document.documentElement.clientHeight}`;
    height.value = Math.trunc(Number(h)/16 - 6) + "rem";
    // console.log(height);
  });

  const handleResize = () => {
    const h = `${document.documentElement.clientHeight}`;
    height.value = Math.trunc(Number(h)/16 - 6) + "rem";
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize);
  });


  



return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "layout-container-demo" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, { style: {"height":"6rem"} }, {
            default: _withCtx(() => [
              _createVNode(Menu)
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, {
            style: _normalizeStyle({height: height.value})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_scrollbar, {
                ref_key: "scrollbarRef",
                ref: scrollbarRef
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_RouterView)
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})